import { RETURN_VALUE_ERROR_CODES, ETHERS_ERROR_CODES } from '../constants';
import type { EthersError, ReturnValue } from '../types';

import { getUnpredictableGasLimitError } from './getUnpredictableGasLimitError';

export function getTopLevelKnownError(ethersError: EthersError): ReturnValue | undefined {
	if (
		ethersError.code === ETHERS_ERROR_CODES.NONCE_EXPIRED &&
		ethersError.transaction !== undefined
	) {
		return {
			title: RETURN_VALUE_ERROR_CODES.NONCE_TOO_LOW,
			description:
				'Can be fixed by incrementing the nonce value to be higher than the last confirmed transaction'
		};
	}

	if (
		ethersError.code === ETHERS_ERROR_CODES.ACTION_REJECTED &&
		ethersError.action === 'sendTransaction'
	) {
		return {
			title: RETURN_VALUE_ERROR_CODES.REJECTED_TRANSACTION,
			description: ethersError.message
		};
	}

	if (ethersError.code === ETHERS_ERROR_CODES.CALL_EXCEPTION && ethersError.reason !== undefined) {
		return {
			title: RETURN_VALUE_ERROR_CODES.CALL_REVERTED,
			description: ethersError.reason
		};
	}

	const unpredictableGasLimitError = getUnpredictableGasLimitError(ethersError);
	if (unpredictableGasLimitError !== undefined) {
		return unpredictableGasLimitError;
	}

	return undefined;
}
